import React from 'react';

const Login = () => (
  <div>
    <h1>404 Page not found</h1>
  </div>
)

export default Login


// WEBPACK FOOTER //
// ./src/scenes/NotFound/NotFound.jsx